import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IBuildInRolePermissions } from '../core/interfaces/build-in-role-permissions.interface';
import { IResponse } from '../core/interfaces/response.interface';
import { RoleModel } from '../core/models/role.model';

@Injectable({ providedIn: 'root' })
export class RoleService {
  constructor(
    private http: HttpClient
  ) {}

  createRole(role: RoleModel): Observable<null> {
    return this.http.post<null>(`${environment.apiUrl}/roles`, role);
  }

  readRoles(payload: { name: string }): Observable<IResponse<RoleModel[]>> {
    return this.http.get<IResponse<RoleModel[]>>(
      `${environment.apiUrl}/roles`,
      {
        params: {
          ...payload,
        },
      }
    );
  }

  readRoleById(roleId: number): Observable<IResponse<RoleModel>> {
    return this.http.get<IResponse<RoleModel>>(
      `${environment.apiUrl}/roles/${roleId}`
    );
  }

  readBuildInRolePermissions(
    buildInRole: string
  ): Observable<IResponse<IBuildInRolePermissions>> {
    return this.http.get<IResponse<IBuildInRolePermissions>>(
      `${environment.apiUrl}/build-in-roles/${buildInRole}/permissions`
    );
  }

  updateRole(role: RoleModel): Observable<null> {
    return this.http.put<null>(`${environment.apiUrl}/roles/${role.id}`, role);
  }

  deleteRole(roleId: number, version: number): Observable<null> {
    return this.http.delete<null>(
      `${environment.apiUrl}/roles/${roleId}/version/${version}`
    );
  }
}
